import * as React from "react";

import ProductOption from "~/components/ProductOptionModeration/ProductOption";
import {
  IModerateOptionsInput,
  IModerationOptionInput
} from "~/graphql/mutations/optionModeration/moderateOptions";
import { IOption } from "~/graphql/queries/optionModeration/optionsPendingImageModeration";
import styled from "~/styled";

interface IProps {
  options: IOption[];
  input: IModerateOptionsInput;
  setOptionInput: (optionId: string, input: IModerationOptionInput) => void;
}

const Grid = styled.div`
  display: grid;
  grid-gap: 12px;
  grid-template-columns: repeat(auto-fill, 300px);
`;

export default class ProductOptionListContainer extends React.Component<
  IProps
> {
  public render() {
    const { input } = this.props;

    return (
      <Grid>
        {this.props.options.map(option => (
          <ProductOption
            key={option.id}
            option={option}
            input={
              input.options.find(
                optionInput => optionInput.nesOptionId === option.id
              )!
            }
            setInput={this.props.setOptionInput}
          />
        ))}
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProductOptionListContainer.tsx